// extracted by mini-css-extract-plugin
export default {"imageSelector":"styles__imageSelector__cEg92"};